import { useEffect, useState } from 'react';
import { HashRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import DropZoneView from './components/dropzone-view.component';
import LoginComponent from './components/login.component';
import { User } from './models/user.model';
import securityService from './services/security.service';
import GroundOpView from './components/ground-op-view.component';
import Menu from './components/menu';
import FlightsView from './components/flights-view.component';

function App() {
  const [authenticatedUser, setAuthenticatedUser] = useState<User | null>(null);

  interface PrivateRouteProps { 
    authenticated: boolean;
    element:JSX.Element
  }

  useEffect(() => { 
    try {
      securityService.authenticatedUser().then( u => {
        setAuthenticatedUser(u);
      });
    } catch(err) {
      setAuthenticatedUser(null);
    }
  }, []);
  

  const ProtectedRoute = (props:PrivateRouteProps) => {
    if (props.authenticated) {
     return props.element;
    }
    return <LoginComponent  loginOk={loginOk} />;
   }

  const loginOk = (user:User | null) => {
    setAuthenticatedUser(user);
  }

  return ( 
    <div className="App"> 
      <HashRouter>
        <Routes>
            <Route path="/" element={<DropZoneView editMode={false}></DropZoneView>}/>
            <Route path="/dropzone-view" element={<DropZoneView editMode={false}></DropZoneView>}/>
            <Route path="/flights-view" element={<FlightsView withTandems={false}></FlightsView>}/>
            <Route path="/flights-view-with-tandems" element={<FlightsView withTandems={true}></FlightsView>}/>

            <Route path="/secured" element={
              <ProtectedRoute authenticated={authenticatedUser!=null} 
                              element={<Menu></Menu>} />
              }>
            </Route>
  
            <Route path="/dropzone-edit" element={
              <ProtectedRoute authenticated={authenticatedUser!=null} 
                              element={<DropZoneView editMode={true}></DropZoneView>} />
              }>
            </Route>
            <Route path="/ground-op-flights-view" element={
              <ProtectedRoute authenticated={authenticatedUser!=null} 
                              element={<GroundOpView editMode={true}></GroundOpView>} />
              }>
            </Route> 
        </Routes>
      </HashRouter>
    </div>
  );
}
export default App;
